export enum TaggingSteps {
  Pitch = 'Pitch',
  Call = 'Call',
  Hit = 'Hit',
  Result = 'Result',
  InPlayResult = 'InPlayResult',
  Final = 'Final',
  Outs = 'Outs',
  Runs = 'Runs',
  CatcherThrows = 'CatcherThrows',
  BaseRunners = 'BaseRunners',
  FieldingSequence = 'FieldingSequence',
}
